<app-collapsible-row
  iconName="move-money"
  class="move-how-row"
  label="Move Money"
  [isRowExpanded]="isRowExpanded()"
  [isRowHasValue]="isRowHasValue()"
>
  @if (isRowHasValue() && !isRowExpanded()) {
    <div class="registry-form-preview">
      <div class="flex flex-col gap-2">
        <div class="preview-content">
          <div class="preview-content-item">
            [{{ moveMoneyDetails()?.selectedMoveItem === 'push' ? 'SEND' : 'REQUEST' }}] via [{{
              $safeNavigationMigration(moveMoneyDetails()?.selectedMoveHowType) | solutionName
            }}]
          </div>
          <div class="preview-content-item">
            @if (!isTemplate()) {
              [{{ moveMoneyDetails()?.moveAmountValue }}] of
            }
            [{{ moveMoneyDetails()?.paymentReasonName }}]
          </div>
        </div>

        @let debitAuthorization = $safeNavigationMigration(moveMoneyDetails()?.financialAccountDetails?.debitAuthorization);
        @if (debitAuthorization) {
          <div class="preview-content">
            <div class="preview-content-item enhance-profile">
              <div class="enhance-profile-details-item">
                <rkt-icon name="card" />
                @if (debitAuthorization?.startDate) {
                  <div class="profile-dot"></div>
                  {{ debitAuthorization?.startDate }}
                }
                <div class="profile-dot"></div>
                {{ debitAuthorization?.occurrenceType }}
                <div class="profile-dot"></div>
                {{ $safeNavigationMigration(moveMoneyDetails()?.moveAmountValue) | currency }}
              </div>
            </div>
          </div>
        }

        @let scheduleDetails = $safeNavigationMigration(moveMoneyDetails()?.scheduleDetails);
        @if (scheduleDetails?.scheduleDateTimeDisplayValue) {
          <div class="preview-content">
            <div class="preview-content-item enhance-profile">
              <div class="enhance-profile-details-item">
                <rkt-icon name="calendar" />
                <div class="profile-dot"></div>
                {{ scheduleDetails?.scheduleDateTimeDisplayValue }}
                @if (scheduleDetails?.scheduleRecurringDisplayValue) {
                  <div class="profile-dot"></div>
                  {{ scheduleDetails?.scheduleRecurringDisplayValue }}
                }
                @if (scheduleDetails?.name) {
                  <div class="profile-dot"></div>
                  {{ scheduleDetails?.name }}
                }
              </div>
            </div>
          </div>
        }
      </div>
      <button class="preview-edit" [disabled]="isEditDisabled()" (click)="expandRow.emit()">
        <rkt-icon name="edit" />
      </button>
    </div>
  }
  <app-linx-move-money-edit
    [hidden]="!isRowExpanded()"
    [isTemplate]="isTemplate()"
    [financialAccountType]="financialAccountType()"
    [profileType]="profileType()"
    [entityId]="entityId()"
    (cleared)="cleared.emit()"
    (continue)="continue.emit($event)"
    [customerId]="customerId()"
  />
</app-collapsible-row>
